import React from 'react';
import { Help } from 'components';

export const HelpPage = props => {
    return <Help {...props} />;
};
